import { Link, useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "@/lib/scrollTo";

const EXPLORE_LINKS = [
  ["Solutions", "/solutions"],
  ["Applications", "/applications"],
  ["Products", "/products"],
  ["Technology", "/technology"],
  ["Economics", "/economics"],
];

const COMPANY_LINKS = [
  ["About", "/about"],
  ["Pilot Program", "/pilot"],
];

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const requestAssessment = () => {
    if (location.pathname === "/") {
      scrollToSection("#contact");
    } else {
      navigate("/#contact");
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0F1720] px-6 pt-[40px] pb-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
      <div className="lg:max-w-[1280px] lg:mx-auto grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-12 gap-x-8 gap-y-12 lg:gap-x-16">
        <div className="col-span-2 sm:col-span-4 lg:col-span-5">
          <span className="font-heading font-semibold text-xl text-white">Off-Grid Hydrogen</span>
          <p className="text-white/45 leading-relaxed text-sm mt-4 max-w-sm">
            Reliable long-duration energy systems
            <br className="lg:hidden" /> for farms
            <br className="hidden lg:block" /> and remote operations.
            <br />
            Serving British Columbia, Canada.
          </p>
        </div>

        <div className="col-span-1 sm:col-span-1 lg:col-span-2">
          <span className="text-sm text-white/40 uppercase tracking-[0.08em]">Explore</span>
          <div className="flex flex-col gap-3 mt-4">
            {EXPLORE_LINKS.map(([label, to]) => (
              <Link
                key={to}
                to={to}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-left text-white/60 hover:text-[#7FE7D4] transition-colors duration-300 text-sm"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>

        <div className="col-span-1 sm:col-span-1 lg:col-span-2">
          <span className="text-sm text-white/40 uppercase tracking-[0.08em]">Company</span>
          <div className="flex flex-col gap-3 mt-4">
            {COMPANY_LINKS.map(([label, to]) => (
              <Link
                key={to}
                to={to}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-left text-white/60 hover:text-[#7FE7D4] transition-colors duration-300 text-sm"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>

        <div className="col-span-2 sm:col-span-2 lg:col-span-2">
          <span className="text-sm text-white/40 uppercase tracking-[0.08em]">Get Started</span>
          <div className="flex flex-col gap-3 mt-4">
            <button
              type="button"
              onClick={requestAssessment}
              data-testid="footer-request-assessment"
              className="text-left text-white/60 hover:text-[#7FE7D4] transition-colors duration-300 text-sm"
            >
              Request Assessment
            </button>
            <a
              href="mailto:info@offgridhydrogen.ca"
              data-testid="footer-email-link"
              className="text-white/60 hover:text-[#7FE7D4] transition-colors duration-300 text-sm"
            >
              info@offgridhydrogen.ca
            </a>
          </div>
        </div>
      </div>

      <div className="lg:max-w-[1280px] lg:mx-auto mt-16 pt-8 border-t border-white/10 flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
        <span data-testid="footer-bottom-line" className="text-xs text-white/30">
          &copy; {new Date().getFullYear()} Off-Grid Hydrogen
        </span>
        <span className="text-xs text-white/30">
          <Link to="/privacy-policy" data-testid="footer-link-privacy-policy" className="hover:text-[#7FE7D4] transition-colors duration-300">
            Privacy Policy
          </Link>{" "}
          &middot;{" "}
          <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-[#7FE7D4] transition-colors duration-300">
            Cookie Policy
          </Link>
        </span>
      </div>
    </footer>
  );
};
